<template>
<div class="row clearfix">
  <div v-if="loading">
    <BlockUI :message="blockuimsg"></BlockUI>
  </div>
  <div class="col-lg-12">
    <b-row>
        <b-col style="text-align:center">
          <h3>Recursos / Enunciados</h3>
        </b-col>
    </b-row>
    <div class="card">
      <div class="tab-content">
        <div class="table-responsive">
          <div class="d-flex justify-content-between align-items-center mb-4 pl-4">
            <b-pagination class="p-0 m-0"
              v-model="currentPage"
              :total-rows="rows"
              :per-page="perPage"
              aria-controls="my-table">
            </b-pagination>
            <div class="d-flex align-items-center pl-3 mr-auto">
              <label class="p-0 m-0 pr-3 text-purple">Filtrar por tags</label>
              <vue-tags-input
                v-model="taglist"
                :autocomplete-items="tagslist"
                :add-only-from-autocomplete="true"
                @tags-changed="updatelist"
              />
            </div>
            <div class="col-md-3">
              <ResourceSearchs :routeApi="'statementsimple'" ref="searchcomponent"
                :perPage = "perPage"
                :newTags2 = "newTags2"
                @update="onUpdateDataResource"
                @loading="onLoading"
              />
            </div>
            <b-button @click="onNew" variant="success">
              + Añadir
            </b-button>
          </div>
          <b-table hover :items="resources"
          :fields="fields"
          :per-page="0"
          :current-page="currentPage"
          >
           <template v-slot:cell(actions)="row">
            <b-button class="btn btn-icon btn-icon-mini btn-round btn-info" @click="info(row.item, row.index, $event.target)">
              <i class="zmdi zmdi-edit"></i>
            </b-button>
             <b-button class="btn btn-icon btn-icon-mini btn-round btn-danger" @click="ondelete(row.item)">
              <i class="fa fa-trash"></i>
            </b-button>
          </template>
          </b-table>
        </div>
      </div>
    </div>
  </div>
  <!-- Info modal -->
  <b-modal :id="infoModal.id" size="xl" :title="infoModal.title" hide-footer>
      <div class="modal-body">
        <ValidationObserver ref="formValidation">
        <b-row>

          <b-col>
          <div>
            <ValidationProvider :rules="{required: true}" v-slot="{ errors }">
              <label for="">Nombre</label>
              <b-form-input
                id="NOMBRE"
                v-model="selectedItem.NOMBRE"
                placeholder="Nombre..." />
              <span class="validation-error">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <br />
          <div>
            <ValidationProvider :rules="{required: true}" v-slot="{ errors }">
              <label>Texto del enunciado</label>
              <div class="col-md-12 d-inline-flex align-items-center p-0 m-0">
                <i class="zmdi zmdi-link pointer pr-2 text-primary"
                          v-if="selectedItem.TEXTOS_ID_ENUNCIADO !== null && selectedItem.TEXTOS_ID_ENUNCIADO !== 0"
                          @click="openResourceWithParam('texts', selectedItem.TEXTOS_ID_ENUNCIADO)"/>
                <input type="text" v-bind:value="getTranslation(selectedItem.text.TEXTO_ENUNCIADO)"
                  disabled class="form-control" />
                <searchtexts class="pl-2" idModal="mdlSearchTextEnunciado"
                  v-on:selected="onSelectedTextEnunciado($event)">
                </searchtexts>
              </div>
              <span class="validation-error">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <div>
            <label>Audio Enunciado</label>
            <div class="col-md-12 d-inline-flex align-items-center p-0 m-0">
              <i class="zmdi zmdi-link pointer pr-2 text-primary"
                        v-if="selectedItem.AUDIOS_ID !== null && selectedItem.AUDIOS_ID !== 0"
                        @click="openResourceWithParam('audios', selectedItem.AUDIOS_ID)"/>
              <i class="zmdi zmdi-close-circle pointer pr-2 text-danger" v-if="selectedItem.AUDIOS_ID !== 0 && selectedItem.AUDIOS_ID !== null" @click="cleanAudio()" />
              <audio :src="getTranslation(selectedItem.text.AUDIO_ENUNCIADO)" controls="controls"
                      style="width:100%" type="audio/mpeg" preload="preload" v-if="selectedItem.AUDIOS_ID !== 0 && selectedItem.AUDIOS_ID !== null">
              </audio>
              <span v-if="selectedItem.AUDIOS_ID === 0 || selectedItem.AUDIOS_ID === null">Sin audio</span>
              <searchaudios class="pl-2" idModal="mdlSearchAudio"
                v-on:selected="onSelectedAudio($event)">
              </searchaudios>
            </div>
          </div>
          <div>
            <label>Imagen Enunciado</label>
            <div class="col-md-12 d-inline-flex align-items-center p-0 m-0">
              <i class="zmdi zmdi-link pointer pr-2 text-primary"
                        v-if="selectedItem.IMAGENES_ID !== null && selectedItem.IMAGENES_ID !== 0"
                        @click="openResourceWithParam('images', selectedItem.IMAGENES_ID)"/>
              <i class="zmdi zmdi-close-circle pointer pr-2 text-danger" v-if="selectedItem.IMAGENES_ID !== 0 && selectedItem.IMAGENES_ID !== null" @click="cleanImage()" />
              <div class="image">
                  <img :src=" getTranslation(selectedItem.text.IMAGEN_ENUNCIADO)" alt="img"
                  style="width:110px;height:110px" class="img-fluid" v-if="selectedItem.IMAGENES_ID !== 0 && selectedItem.IMAGENES_ID !== null">
                  <span v-if="selectedItem.IMAGENES_ID === 0 || selectedItem.IMAGENES_ID === null">Sin imagen</span>
              </div>
              <searchimages class="pl-2" idModal="mdlSearchImage"
                v-on:selected="onSelectedImage($event)">
              </searchimages>
            </div>
          </div>
          <br />
          <div class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input"
            v-model="selectedItem.SUB"
            id="SUB">
            <label class="custom-control-label" for="SUB">
              Subproblema</label>
          </div>
          <div class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input"
            v-model="selectedItem.CC"
            id="CC">
            <label class="custom-control-label" for="CC">
              Cambiar cantidades</label>
          </div>
          <div class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input"
            v-model="selectedItem.CU"
            id="CU">
            <label class="custom-control-label" for="CU">
              Cambiar unidades</label>
          </div>
          <div class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input"
            v-model="selectedItem.EST"
            id="EST">
            <label class="custom-control-label" for="EST">
              Estimación</label>
          </div>
          <br />
          <div v-if="selectedItem.EST === 1 || selectedItem.EST === true">
            <div>
              <ValidationProvider :rules="{required: selectedItem.EST === 1 || selectedItem.EST === true ? true : false}" v-slot="{ errors }">
                <label>Respuesta Correcta</label>
                <div class="col-md-12 d-inline-flex align-items-center p-0 m-0">
                  <i class="zmdi zmdi-link pointer pr-2 text-primary"
                            v-if="selectedItem.TEXTOS_ID_EST_COR !== null && selectedItem.TEXTOS_ID_EST_COR !== 0"
                            @click="openResourceWithParam('texts', selectedItem.TEXTOS_ID_EST_COR)"/>
                  <input type="text" v-bind:value="getTranslation(selectedItem.responses.TEXTOS_EST_COR)"
                  disabled class="form-control" />
                  <searchtexts class="pl-2" idModal="mdlSearchTextResponse_Correcta"
                    v-on:selected="onSelectedTextResponse($event, 0)">
                  </searchtexts>
                </div>
                <span class="validation-error">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div>
              <ValidationProvider :rules="{required: selectedItem.EST === 1 || selectedItem.EST === true ? true : false}" v-slot="{ errors }">
                <label>Respuesta erronea 1</label>
                <div class="col-md-12 d-inline-flex align-items-center p-0 m-0">
                  <i class="zmdi zmdi-link pointer pr-2 text-primary"
                            v-if="selectedItem.TEXTOS_ID_EST_INC1 !== null && selectedItem.TEXTOS_ID_EST_INC1 !== 0"
                            @click="openResourceWithParam('texts', selectedItem.TEXTOS_ID_EST_INC1)"/>
                  <input type="text" v-bind:value="getTranslation(selectedItem.responses.TEXTOS_EST_INC1)" disabled class="form-control" />
                  <searchtexts class="pl-2" idModal="mdlSearchTextResponse_INC1"
                    v-on:selected="onSelectedTextResponse($event, 1)">
                  </searchtexts>
                </div>
                <span class="validation-error">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div>
              <ValidationProvider :rules="{required: selectedItem.EST === 1 || selectedItem.EST === true ? true : false}" v-slot="{ errors }">
                <label>Respuesta erronea 2</label>
                <div class="col-md-12 d-inline-flex align-items-center p-0 m-0">
                  <i class="zmdi zmdi-link pointer pr-2 text-primary"
                            v-if="selectedItem.TEXTOS_ID_EST_INC2 !== null && selectedItem.TEXTOS_ID_EST_INC2 !== 0"
                            @click="openResourceWithParam('texts', selectedItem.TEXTOS_ID_EST_INC2)"/>
                  <input type="text" v-bind:value="getTranslation(selectedItem.responses.TEXTOS_EST_INC2)" disabled class="form-control" />
                  <searchtexts class="pl-2" idModal="mdlSearchTextResponse_INC2"
                    v-on:selected="onSelectedTextResponse($event, 2)">
                  </searchtexts>
                </div>
                <span class="validation-error">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div>
              <!--<ValidationProvider :rules="{required: selectedItem.EST === 1 || selectedItem.EST === true ? true : false}" v-slot="{ errors }">-->
                <label>Respuesta erronea 3</label>
                <div class="col-md-12 d-inline-flex align-items-center p-0 m-0">
                  <i class="zmdi zmdi-link pointer pr-2 text-primary"
                            v-if="selectedItem.TEXTOS_ID_EST_INC3 !== null && selectedItem.TEXTOS_ID_EST_INC3 !== 0"
                            @click="openResourceWithParam('texts', selectedItem.TEXTOS_ID_EST_INC3)"/>
                  <input type="text" v-bind:value="getTranslation(selectedItem.responses.TEXTOS_EST_INC3)" disabled class="form-control" />
                  <searchtexts class="pl-2" idModal="mdlSearchTextResponse_INC3"
                    v-on:selected="onSelectedTextResponse($event, 3)">
                  </searchtexts>
                </div>
                <!--<span class="validation-error">{{ errors[0] }}</span>
              </ValidationProvider>-->
            </div>
            <div>
              <!--<ValidationProvider :rules="{required: selectedItem.EST === 1 || selectedItem.EST === true ? true : false}" v-slot="{ errors }">-->
                <label>Respuesta erronea 4</label>
                <div class="col-md-12 d-inline-flex align-items-center p-0 m-0">
                  <i class="zmdi zmdi-link pointer pr-2 text-primary"
                            v-if="selectedItem.TEXTOS_ID_EST_INC4 !== null && selectedItem.TEXTOS_ID_EST_INC4 !== 0"
                            @click="openResourceWithParam('texts', selectedItem.TEXTOS_ID_EST_INC4)"/>
                  <input type="text" v-bind:value="getTranslation(selectedItem.responses.TEXTOS_EST_INC4)" disabled class="form-control" />
                  <searchtexts class="pl-2" idModal="mdlSearchTextResponse_INC4"
                    v-on:selected="onSelectedTextResponse($event, 4)">
                  </searchtexts>
                </div>
                <!--<span class="validation-error">{{ errors[0] }}</span>
              </ValidationProvider>-->
            </div>
          </div>
        </b-col>

        <b-col>
          <div>
            Tipo de problema <select class="form-control" v-model="selectedItem.TIPO_PROBLEMA_SIMPLE_ID">
              <option v-for="option in problemstype" v-bind:value="option.ID" v-bind:key="option.ID">
                {{ option.NOMBRE }}
              </option>
            </select>
          </div>
          <br />
          <div>
            Tipo de numeración <select class="form-control" v-model="selectedItem.TIPO_NUMERACION_ID">
              <option v-for="option in numerationstype" v-bind:value="option.ID" v-bind:key="option.ID">
                {{ option.NOMBRE }}
              </option>
            </select>
          </div>
          <br />
          <div class="row">
            <div class="col-md-3">
              Cantidad 1
              <b-form-input v-model="selectedItem.OP1C"
                type="text">
              </b-form-input>
            </div>
            <div class="col-md-9">
              Unidad 1
              <div class="col-md-12 d-inline-flex align-items-center p-0 m-0">
                <i class="zmdi zmdi-link pointer pr-2 text-primary"
                        v-if="selectedItem.UNIDAD1_ID !== null && selectedItem.UNIDAD1_ID !== 0"
                        @click="openResourceWithParam('unitmath', selectedItem.UNIDAD1_ID)"/>
                <i class="zmdi zmdi-close-circle pointer pr-2 text-danger" v-if="selectedItem.UNIDAD1_ID !== null" @click="cleanUnit(1)"/>
                <input type="text" v-bind:value="getTranslation(selectedItem.text.UNIDAD1_TEXTO)" disabled class="form-control" />
                <searchunitmath class="pl-2" idModal="mdlSearchUnitMath1"
                  v-on:selected="onSelectedUnitMath($event, 0)">
                </searchunitmath>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3">
              Cantidad 2
              <b-form-input v-model="selectedItem.OP2C"
                type="text">
              </b-form-input>
            </div>
            <div class="col-md-9">
              Unidad 2
              <div class="col-md-12 d-inline-flex align-items-center p-0 m-0">
                <i class="zmdi zmdi-link pointer pr-2 text-primary"
                        v-if="selectedItem.UNIDAD2_ID !== null && selectedItem.UNIDAD2_ID !== 0"
                        @click="openResourceWithParam('unitmath', selectedItem.UNIDAD2_ID)"/>
                <i class="zmdi zmdi-close-circle pointer pr-2 text-danger" v-if="selectedItem.UNIDAD2_ID !== null" @click="cleanUnit(2)"/>
                <input type="text" v-bind:value="getTranslation(selectedItem.text.UNIDAD2_TEXTO)" disabled class="form-control" />
                <searchunitmath class="pl-2" idModal="mdlSearchUnitMath2"
                  v-on:selected="onSelectedUnitMath($event, 1)">
                </searchunitmath>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3">
              Cantidad 3
              <b-form-input v-model="selectedItem.OP3C"
                type="text">
              </b-form-input>
            </div>
            <div class="col-md-9">
              Unidad 3
              <div class="col-md-12 d-inline-flex align-items-center p-0 m-0">
                <i class="zmdi zmdi-link pointer pr-2 text-primary"
                        v-if="selectedItem.UNIDAD3_ID !== null && selectedItem.UNIDAD3_ID !== 0"
                        @click="openResourceWithParam('unitmath', selectedItem.UNIDAD3_ID)"/>
                <i class="zmdi zmdi-close-circle pointer pr-2 text-danger" v-if="selectedItem.UNIDAD3_ID !== null" @click="cleanUnit(3)"/>
                <input type="text" v-bind:value="getTranslation(selectedItem.text.UNIDAD3_TEXTO)" disabled class="form-control" />
                <searchunitmath class="pl-2" idModal="mdlSearchUnitMath3"
                  v-on:selected="onSelectedUnitMath($event, 2)">
                </searchunitmath>
              </div>
            </div>
          </div>
          <br />
          <div>
            <ValidationProvider :rules="{required: true}" v-slot="{ errors }">
              <label>Plantilla</label>
              <div class="col-md-12 d-inline-flex align-items-center p-0 m-0">
                <i class="zmdi zmdi-link pointer pr-2 text-primary"
                          v-if="selectedItem.PLANTILLAS_ID !== null && selectedItem.PLANTILLAS_ID !== 0"
                          @click="openResourceWithParam('templates', selectedItem.PLANTILLAS_ID)"/>
                <b-form-textarea
                    id="textarea"
                    disabled class="form-control"
                    v-bind:value="getTranslation(selectedItem.text.PLANTILLA)"
                    placeholder="Texto de la plantilla..."
                    rows="9"
                    max-rows="9"
                    :readonly=true >
                </b-form-textarea>
                <searchtemplates class="p-2" idModal="mdlSearchTemplate"
                  v-on:selected="onSelectedTemplate($event)">
                </searchtemplates>
              </div>
              <span class="validation-error">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
        </b-col>

      </b-row>

        <br />
        <label for="Tag">
        <br>
          Etiquetas</label>
            <div>
            <vue-tags-input
              v-model="tag"
              :tags="tags"
              :autocomplete-items="autocompleteItems"
              @tags-changed="update"
            />
          </div>
        <div class="modal-footer">
          <button type="button" @click="save"
          class="btn btn-info btn-round waves-effect">
            Guardar</button>
          <b-button class="btn btn-default btn-round waves-effect" block
          @click="$bvModal.hide('info-modal')">Cerrar</b-button>
        </div>
      </ValidationObserver>
    </div>
  </b-modal>
</div>

</template>

<script>
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import VueTagsInput from '@johmun/vue-tags-input';
import searchtexts from '../texts/SearchTexts.vue';
import searchimages from '../images/SearchImages.vue';
import searchaudios from '../audios/SearchAudios.vue';
import searchtemplates from '../templates/SearchTemplates.vue';
import searchunitmath from '../units/SearchUnitmath.vue';
import ResourceSearchs from '../../../components/panel/ResourceSearchs.vue';
import searchMixin from '../../../mixins/search';
import translationMixin from '../../../mixins/translation';

extend('required', {
  ...required,
  message: 'Campo obligatorio.',
});

export default {
  components: {
    VueTagsInput,
    searchtexts,
    searchimages,
    searchaudios,
    searchtemplates,
    searchunitmath,
    ResourceSearchs,
    ValidationProvider,
    ValidationObserver,
  },
  name: 'gridStatementSimples',
  mixins: [searchMixin, translationMixin],
  data() {
    return {
      perPage: 20,
      rows: 0,
      currentPage: 1,
      problemstype: [],
      numerationstype: [],
      fields: [
        { key: 'NOMBRE', label: 'Nombre' },
        { key: 'TIPO_PROBLEMA', label: 'Tipo problema' },
        { key: 'TIPO_NUMERACION', label: 'Tipo numeración' },
        { key: 'SUB', label: 'Subproblema' },
        { key: 'actions', label: 'Acciones', tdClass: 'tdActionClass' },
      ],
      resources: [],
      selectedItem: {
        ID: null,
        NOMBRE: null, // Nombre descriptivo para buscar
        TEXTOS_ID_ENUNCIADO: null, // Enlace al enunciado
        OP1C: null, // Cantidad del primer dato de la operación aritmética
        UNIDAD1_ID: null, // Enlace a la unidad del primer dato de la operación aritmética
        OP2C: null, // Cantidad del segundo dato de la operación aritmética
        UNIDAD2_ID: null, // Enlace a la unidad del segundo dato de la operación aritmética
        OP3C: null, // Cantidad del tercer dato de la operación aritmética
        UNIDAD3_ID: null, // Enlace a la unidad del tercer dato de la operación aritmética
        SUB: null, // Es subproblema: 0 No 1 Si
        CC: null, // Permite cambiar cantidades en el ejercicio: 0 No 1 Si
        CU: null, // Permite cambiar unidades en el ejercicio: 0 No 1 Si
        EST: null, // Tiene respuesta personalizadas (estimación)
        TEXTOS_ID_EST_COR: null, // Enlace al texto de la respuesta correcta
        TEXTOS_ID_EST_INC1: null, // Enlace al texto de la respuesta incorrecta
        TEXTOS_ID_EST_INC2: null, // Enlace al texto de la respuesta incorrecta
        TEXTOS_ID_EST_INC3: null, // Enlace al texto de la respuesta incorrecta
        TEXTOS_ID_EST_INC4: null, // Enlace al texto de la respuesta incorrecta
        TIPO_PROBLEMA_SIMPLE_ID: 1, // Relación con el tipo de problema
        TIPO_NUMERACION_ID: 1, // Relación con el tipo de numeración
        AUDIOS_ID: 0, // Enlace al audio que acompaña al enunciado, 0 si no tiene
        IMAGENES_ID: 0, // Enlace a la imagen que acompaña al enunciado, 0 si no tiene
        PLANTILLAS_ID: null, // Enlace a las plantillas
        text: { // Used for display
          UNIDAD1_TEXTO: [],
          UNIDAD2_TEXTO: [],
          UNIDAD3_TEXTO: [],
          TEXTO_ENUNCIADO: [],
          AUDIO_ENUNCIADO: [],
          IMAGEN_ENUNCIADO: [],
          UNIDAD1_TEXTO_SINGULAR: null,
          UNIDAD2_TEXTO_SINGULAR: null,
          UNIDAD3_TEXTO_SINGULAR: null,
          PLANTILLA: [],
        },
        responses: { // Used for display
          TEXTOS_EST_COR: [],
          TEXTOS_EST_INC1: [],
          TEXTOS_EST_INC2: [],
          TEXTOS_EST_INC3: [],
          TEXTOS_EST_INC4: [],
        },
      },
      infoModal: {
        id: 'info-modal',
        title: '',
        content: '',
      },
      tag: '',
      taglist: '',
      tags: [],
      newTags: [],
      newTags2: [],
      tagslist: [],
      autocompleteItems: [],
    };
  },
  methods: {
    async getProblemsType() {
      this.loading = true;
      try {
        const response = await this.axios.get('problemstype/getproblemstype');
        this.problemstype = response.data;
        this.loading = false;
      } catch (e) {
        this.loading = false;
      }
    },
    /**
     * Obtener tipos de numeracion
     */
    async getNumerationType() {
      this.loading = true;
      try {
        const response = await this.axios.get('numerationtype/getnumerationtype');
        this.numerationstype = response.data;
        this.loading = false;
      } catch (e) {
        this.loading = false;
      }
    },
    /**
    * @method onSelectedText
    * @description Al seleccionar un texto
    */
    onSelectedTextEnunciado(itemSelected) {
      this.selectedItem.TEXTOS_ID_ENUNCIADO = itemSelected.ID;
      this.selectedItem.text.TEXTO_ENUNCIADO = [];
      this.setTranslation('TEXTO_', itemSelected, this.selectedItem.text.TEXTO_ENUNCIADO);
      this.$root.$emit('bv::hide::modal', 'mdlSearchTextEnunciado');
    },
    onSelectedTextResponse(itemSelected, id) {
      switch (id) {
        case 0:
          // Respuesta Correcta
          this.selectedItem.TEXTOS_ID_EST_COR = itemSelected.ID;
          this.selectedItem.responses.TEXTOS_EST_COR = [];
          this.setTranslation('TEXTO_', itemSelected, this.selectedItem.responses.TEXTOS_EST_COR);
          this.$root.$emit('bv::hide::modal', 'mdlSearchTextResponse_Correcta');
          break;
        case 1:
          // Respuesta Erronea 1
          this.selectedItem.TEXTOS_ID_EST_INC1 = itemSelected.ID;
          this.selectedItem.responses.TEXTOS_EST_INC1 = [];
          this.setTranslation('TEXTO_', itemSelected, this.selectedItem.responses.TEXTOS_EST_INC1);
          this.$root.$emit('bv::hide::modal', 'mdlSearchTextResponse_INC1');
          break;
        case 2:
          // Respuesta Erronea 2
          this.selectedItem.TEXTOS_ID_EST_INC2 = itemSelected.ID;
          this.selectedItem.responses.TEXTOS_EST_INC2 = [];
          this.setTranslation('TEXTO_', itemSelected, this.selectedItem.responses.TEXTOS_EST_INC2);
          this.$root.$emit('bv::hide::modal', 'mdlSearchTextResponse_INC2');
          break;
        case 3:
          // Respuesta Erronea 3
          this.selectedItem.TEXTOS_ID_EST_INC3 = itemSelected.ID;
          this.selectedItem.responses.TEXTOS_EST_INC3 = [];
          this.setTranslation('TEXTO_', itemSelected, this.selectedItem.responses.TEXTOS_EST_INC3);
          this.$root.$emit('bv::hide::modal', 'mdlSearchTextResponse_INC3');
          break;
        case 4:
          // Respuesta Erronea 4
          this.selectedItem.TEXTOS_ID_EST_INC4 = itemSelected.ID;
          this.selectedItem.responses.TEXTOS_EST_INC4 = [];
          this.setTranslation('TEXTO_', itemSelected, this.selectedItem.responses.TEXTOS_EST_INC4);
          this.$root.$emit('bv::hide::modal', 'mdlSearchTextResponse_INC4');
          break;
        default:
          break;
      }
    },
    /**
    * @method cleanAudio
    * @description Limpia el audio
    */
    cleanAudio() {
      this.selectedItem.AUDIOS_ID = 0;
      this.selectedItem.text.AUDIO_ENUNCIADO = [];
    },
    /**
    * @method onSelectedAudio
    * @description Al seleccionar un audio
    */
    onSelectedAudio(itemSelected) {
      this.selectedItem.AUDIOS_ID = itemSelected.ID;
      this.selectedItem.text.AUDIO_ENUNCIADO = [];
      this.selectedItem.text.AUDIO_ENUNCIADO = itemSelected.FICHERO;
      // this.setTranslation('FICHERO_', itemSelected, this.selectedItem.text.AUDIO_ENUNCIADO);
      this.$root.$emit('bv::hide::modal', 'mdlSearchAudio');
    },
    /**
    * @method cleanImage
    * @description Limpia la imagen
    */
    cleanImage() {
      this.selectedItem.IMAGENES_ID = 0;
      this.selectedItem.text.IMAGEN_ENUNCIADO = [];
    },
    /**
    * @method onSelectedImage
    * @description Al seleccionar una imagen
    */
    onSelectedImage(itemSelected) {
      this.selectedItem.IMAGENES_ID = itemSelected.ID;
      this.selectedItem.text.IMAGEN_ENUNCIADO = [];
      this.selectedItem.text.IMAGEN_ENUNCIADO = itemSelected.FICHERO;
      this.setTranslation('FICHERO_', itemSelected, this.selectedItem.text.IMAGEN_ENUNCIADO);
      this.$root.$emit('bv::hide::modal', 'mdlSearchImage');
    },
    onSelectedUnitMath(itemSelected, id) {
      switch (id) {
        case 0:
          // Unidad 1
          this.selectedItem.UNIDAD1_ID = itemSelected.ID;
          this.selectedItem.text.UNIDAD1_TEXTO = [];
          this.setTranslation('TEXTO_SINGULAR_', itemSelected, this.selectedItem.text.UNIDAD1_TEXTO);
          this.$root.$emit('bv::hide::modal', 'mdlSearchUnitMath1');
          break;
        case 1:
          // Unidad 2
          this.selectedItem.UNIDAD2_ID = itemSelected.ID;
          this.selectedItem.text.UNIDAD2_TEXTO = [];
          this.setTranslation('TEXTO_SINGULAR_', itemSelected, this.selectedItem.text.UNIDAD2_TEXTO);
          this.$root.$emit('bv::hide::modal', 'mdlSearchUnitMath2');
          break;
        case 2:
          // Unidad 3
          this.selectedItem.UNIDAD3_ID = itemSelected.ID;
          this.selectedItem.text.UNIDAD3_TEXTO = [];
          this.setTranslation('TEXTO_SINGULAR_', itemSelected, this.selectedItem.text.UNIDAD3_TEXTO);
          this.$root.$emit('bv::hide::modal', 'mdlSearchUnitMath3');
          break;
        default:
          break;
      }
    },
    /**
     * Seleccionar una plantilla
     */
    onSelectedTemplate(itemSelected) {
      this.selectedItem.PLANTILLAS_ID = itemSelected.ID;
      this.selectedItem.text.PLANTILLA = [];
      this.setTranslation('PLANTILLA_', itemSelected, this.selectedItem.text.PLANTILLA);
      this.$root.$emit('bv::hide::modal', 'mdlSearchTemplate');
    },
    onNew() {
      this.limpiar();
      this.infoModal.title = 'Nuevo enunciado simple';
      this.$root.$emit('bv::show::modal', this.infoModal.id);
    },
    cleanUnit(id) {
      switch (id) {
        case 1:
          this.selectedItem.UNIDAD1_ID = null;
          this.selectedItem.text.UNIDAD1_TEXTO = [];
          break;
        case 2:
          this.selectedItem.UNIDAD2_ID = null;
          this.selectedItem.text.UNIDAD2_TEXTO = [];
          break;
        case 3:
          this.selectedItem.UNIDAD3_ID = null;
          this.selectedItem.text.UNIDAD3_TEXTO = [];
          break;
        default:
          break;
      }
    },
    limpiar() {
      this.selectedItem.ID = null;
      this.selectedItem.NOMBRE = null;
      this.selectedItem.TEXTOS_ID_ENUNCIADO = null;
      this.selectedItem.OP1C = null;
      this.selectedItem.UNIDAD1_ID = null;
      this.selectedItem.OP2C = null;
      this.selectedItem.UNIDAD2_ID = null;
      this.selectedItem.OP3C = null;
      this.selectedItem.UNIDAD3_ID = null;
      this.selectedItem.SUB = null;
      this.selectedItem.CC = null;
      this.selectedItem.CU = null;
      this.selectedItem.EST = null;
      this.selectedItem.TEXTOS_ID_EST_COR = null;
      this.selectedItem.TEXTOS_ID_EST_INC1 = null;
      this.selectedItem.TEXTOS_ID_EST_INC2 = null;
      this.selectedItem.TEXTOS_ID_EST_INC3 = null;
      this.selectedItem.TEXTOS_ID_EST_INC4 = null;
      this.selectedItem.TIPO_PROBLEMA_SIMPLE_ID = 1;
      this.selectedItem.TIPO_NUMERACION_ID = 1;
      this.selectedItem.AUDIOS_ID = null;
      this.selectedItem.IMAGENES_ID = null;
      this.selectedItem.PLANTILLAS_ID = null;
      // Text to show on forms
      this.selectedItem.text.UNIDAD1_TEXTO = [];
      this.selectedItem.text.UNIDAD2_TEXTO = [];
      this.selectedItem.text.UNIDAD3_TEXTO = [];
      this.selectedItem.text.TEXTO_ENUNCIADO = [];
      this.selectedItem.text.AUDIO_ENUNCIADO = [];
      this.selectedItem.text.IMAGEN_ENUNCIADO = [];
      this.selectedItem.text.UNIDAD1_TEXTO_SINGULAR = null;
      this.selectedItem.text.UNIDAD2_TEXTO_SINGULAR = null;
      this.selectedItem.text.UNIDAD3_TEXTO_SINGULAR = null;
      this.selectedItem.text.PLANTILLA = [];
      // responses
      this.selectedItem.responses.TEXTOS_EST_COR = [];
      this.selectedItem.responses.TEXTOS_EST_INC1 = [];
      this.selectedItem.responses.TEXTOS_EST_INC2 = [];
      this.selectedItem.responses.TEXTOS_EST_INC3 = [];
      this.selectedItem.responses.TEXTOS_EST_INC4 = [];
      this.tag = '';
      this.tags = [];
    },
    async ondelete(item) {
      const confirmation = await this.$bvModal.msgBoxConfirm('Esta a punto de eliminar un registro ¿Esta seguro?');
      if (confirmation) {
        /** Elimino los tags asociados */
        const url = `Tagsstatementsimple/deleteTags/${item.ID}`;
        this.axios.get(url);

        this.loading = true;
        const response = await this.axios.post('statementsimple/delete', { ID: item.ID });
        if (response.data.status === 'success') {
          this.loading = false;
          this.$toasted.show('Se elimino el registro seleccionado.', { theme: 'outline', type: 'success', duration: 5000 });
          this.getPostData();
        } else {
          this.loading = false;
          this.$toasted.show(response.data.message, { theme: 'outline', type: 'error', duration: 5000 });
        }
      }
    },
    async info(item, index, button) {
      this.infoModal.title = 'Editar Enunciado';

      this.loading = true;
      try {
        const response = await this.axios.get('statementsimple/getstatement', {
          params: {
            id: item.ID,
          },
        });
        this.selectedItem = response.data.content;
      } catch (e) {
        this.$toasted.show('Ocurrió un error al leer el contenido', { type: 'warning' });
      }

      await this.getExistingTags(item.ID);
      this.loading = false;
      this.$root.$emit('bv::show::modal', this.infoModal.id, button);
    },
    async save() {
      this.$refs.formValidation.validate().then(async (success) => {
        if (!success) {
          return;
        }
        this.loading = true;
        const unitData = {
          ID: this.selectedItem.ID || -1,
          NOMBRE: this.selectedItem.NOMBRE,
          TEXTOS_ID_ENUNCIADO: this.selectedItem.TEXTOS_ID_ENUNCIADO,
          OP1C: this.selectedItem.OP1C,
          UNIDAD1_ID: this.selectedItem.UNIDAD1_ID,
          OP2C: this.selectedItem.OP2C,
          UNIDAD2_ID: this.selectedItem.UNIDAD2_ID,
          OP3C: this.selectedItem.OP3C,
          UNIDAD3_ID: this.selectedItem.UNIDAD3_ID,
          SUB: this.selectedItem.SUB,
          CC: this.selectedItem.CC,
          CU: this.selectedItem.CU,
          EST: this.selectedItem.EST,
          TEXTOS_ID_EST_COR: this.selectedItem.TEXTOS_ID_EST_COR,
          TEXTOS_ID_EST_INC1: this.selectedItem.TEXTOS_ID_EST_INC1,
          TEXTOS_ID_EST_INC2: this.selectedItem.TEXTOS_ID_EST_INC2,
          TEXTOS_ID_EST_INC3: this.selectedItem.TEXTOS_ID_EST_INC3,
          TEXTOS_ID_EST_INC4: this.selectedItem.TEXTOS_ID_EST_INC4,
          TIPO_PROBLEMA_SIMPLE_ID: this.selectedItem.TIPO_PROBLEMA_SIMPLE_ID,
          TIPO_NUMERACION_ID: this.selectedItem.TIPO_NUMERACION_ID,
          AUDIOS_ID: this.selectedItem.AUDIOS_ID,
          IMAGENES_ID: this.selectedItem.IMAGENES_ID,
          PLANTILLAS_ID: this.selectedItem.PLANTILLAS_ID,
        };
        try {
          const response = await this.axios.post('statementsimple/store', unitData);
          if (response.data.status === 'success') {
            // Solo si esta creando agrego el evento
            if (this.selectedItem.ID === -1 || this.selectedItem.ID === null) {
              const bc = new BroadcastChannel('new_resource_statements_simple');
              bc.postMessage({
                ID: response.data.id,
                NOMBRE: this.selectedItem.NOMBRE,
                SUB: this.selectedItem.SUB ? 1 : 0,
              });
            }

            const url = `Tagsstatementsimple/deleteTags/${response.data.id}`;
            const url2 = 'Tagsstatementsimple/saveTag';

            this.axios.get(url);
            this.newTags.forEach((a) => {
              this.axios.get(`Tags/findTagByName/${a.text}`,
                { name: a.text }).then((resp) => {
                if (resp.data.status === 'success') {
                  this.axios.post(url2, { id: resp.data.id, idtexto: response.data.id });
                } else {
                  this.axios.post(url2, { id: a.key, idtexto: response.data.id });
                }
              });
            });

            this.$toasted.show('Los datos se guardaron satisfactoriamente.', { theme: 'outline', type: 'success', duration: 5000 });
            this.$root.$emit('bv::hide::modal', this.infoModal.id);
            this.limpiar();

            // Auto close if coming from a create event
            if (this.bAutoClose) {
              window.open('', '_self').close();
            }

            await this.getPostData();
          } else {
            this.$toasted.show(response.data.message, { theme: 'outline', type: 'error', duration: 5000 });
          }
          this.loading = false;
        } catch (e) {
          const resp = e;
          if (!resp.body.Ok) {
            this.$toasted.show(resp.body.Message, { theme: 'outline', type: 'error', duration: 5000 });
          }
          this.loading = false;
        }
      });
    },
    async getContents() {
      this.loading = true;

      try {
        const response = await this.axios.get('statementsimple');
        this.resources = response.data;
        this.loading = false;
      } catch (e) {
        this.loading = false;
      }
    },
    async getPostData() {
      this.loading = true;
      try {
        const response = await this.axios.get('statementsimple', {
          params: {
            currentPage: this.currentPage,
            size: this.perPage,
            newTags: this.newTags2,
            resourcetosearch: this.$refs.searchcomponent.resoursetosearch,
          },
        });
        this.rows = response.data.rows;
        this.resources = Object.keys(response.data.results).map(k => response.data.results[k]);
        this.loading = false;
      } catch (e) {
        this.loading = false;
      }
    },
    updatelist(newTags) {
      this.newTags2 = newTags;
      this.getPostData();
    },
    listTags() {
      const url = 'Tags';
      const datos = [];
      this.axios.get(url).then((res) => {
        res.data.forEach((a) => {
          datos.push({ key: a.ID, text: a.NOMBRE });
        });
        this.tagslist = datos;
      })
        .catch((error) => {
          console.error(error);
        });
      this.loading = false;
    },
    initItems() {
      const url = 'Tags';
      const datos = [];

      this.axios.get(url).then((res) => {
        res.data.forEach((a) => {
          datos.push({ text: a.NOMBRE, key: a.ID });
        });
        this.autocompleteItems = datos;
      })
        .catch((error) => {
          console.error(error);
        });
      this.loading = false;
    },
    update(newTags) {
      this.tags = newTags;
      this.newTags = newTags;
    },
    async getExistingTags(idtxt) {
      const url = `Tagsstatementsimple/findByStatementSimple/${idtxt}`;
      const datos = [];
      this.loading = true;

      try {
        this.axios.get(url).then((res) => {
          res.data.forEach((a) => {
            datos.push({ text: a.NOMBRE, key: a.ID });
          });
          this.tags = datos;
        })
          .catch((error) => {
            console.error(error);
          });
        this.loading = false;
      } catch (e) {
        console.log(e);
        this.loading = false;
      }
    },
  },
  async mounted() {
    await this.getPostData();
    this.initItems();
    this.listTags();
    this.getProblemsType();
    this.getNumerationType();

    // Open create modal automatically
    const self = this;
    const bc = new BroadcastChannel('new_resource_statements_simple_open');
    bc.onmessage = () => {
      self.bAutoClose = true;
      self.onNew();
    };

    // Get params Id for edit
    if (this.$route.params.id != null) {
      const item = {
        ID: this.$route.params.id,
      };
      this.info(item, null, null);
    }
  },
  watch: {
    currentPage: {
      handler() {
        this.getPostData().catch((error) => {
          console.error(error);
        });
      },
    },
  },
};
</script>
<style>
  .tdActionClass{
    width: 180px;
    text-align: center
  }
</style>
